module.exports = __webpack_public_path__ + "media/images/icons/icon_sort_gray-a3cbfd9c35074199871773a0040c19f4.svg";